import styled from '@emotion/styled';
import { themeColors } from 'theme/theme.config';

export const STableActiveCell = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  
  &:hover {
    border: 1px solid ${themeColors.character.title85};
    margin: 0 -1px;
  }
`;

export const STableCellPlaceholder = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${themeColors.character.title25};
`;
